import { render, staticRenderFns } from "./CustomArea.vue?vue&type=template&id=0f4d266c"
import script from "./CustomArea.vue?vue&type=script&lang=js"
export * from "./CustomArea.vue?vue&type=script&lang=js"
import style0 from "./CustomArea.vue?vue&type=style&index=0&id=0f4d266c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports